export const translations = {
    zh: {
        login: {
            title: '民宿保洁管理',
            subtitle: '请登录您的账号',
            testAccount: '测试账号',
            password: '密码',
            emailLabel: '邮箱',
            emailPlaceholder: '请输入邮箱',
            passwordLabel: '密码',
            passwordPlaceholder: '请输入密码',
            captchaLabel: '验证码',
            captchaPlaceholder: '验证码',
            loginButton: '登录',
            loggingIn: '登录中...',
            registerLink: '没有账号？立即注册',
            success: '登录成功！正在跳转...',
            errorMissing: '请输入邮箱和密码',
            errorCaptcha: '验证码错误',
            errorLogin: '登录失败，请检查邮箱和密码',
            errorBanned: '账号被禁用',
        },
        tasks: {
            title: '我的任务',
            today: '今日任务',
            history: '历史任务',
            emptyToday: '今天没有任务啦，休息一下吧！',
            emptyHistory: '暂无历史任务记录',
            planTime: '计划时间',
            cleaningTime: '清扫时间',
            checkOutDate: '退房时间',
            rooms: '个房间',
            reworkReason: '原因',
        },
        workPlan: {
            entryButton: '工作计划提交',
            kicker: 'Work Plan',
            title: '工作计划提交',
            back: '返回任务',
            currentUser: '当前提交人',
            loadingUser: '识别中',
            loadingWarehouse: '仓库加载中',
            warehouse: '所属仓库',
            noWarehouse: '当前账号还没有可提交的仓库，请联系管理员。',
            prevWeek: '上周',
            nextWeek: '下周',
            weekTitle: '下一周可上班时间',
            workDaysUnit: ' 天可上班',
            available: '可上班',
            notePlaceholder: '备注',
            submit: '提交下一周可上班时间',
            saving: '提交中...',
            saved: '可上班时间已提交',
            loadFailed: '工作计划加载失败，请稍后重试。',
            saveFailed: '工作计划提交失败，请稍后重试。',
            mySchedule: '我的排班',
            unassigned: '未安排',
            scheduleEmpty: '暂无排班数据',
        },
        taskDetail: {
            title: '执行任务',
            historyTitle: '历史任务',
            reworkReason: '返工原因：',
            standardExample: '标准示例',
            myPhoto: '我的照片',
            clickUpload: '点击上传',
            submit: '完成并提交',
            submitting: '提交中...',
            cleanerRemarks: '打扫备注',
            cantSubmitTitle: '无法提交',
            cantSubmitMsg: '请确保所有必拍项都已上传照片，并且所有项目都已勾选完成。',
            ok: '好的',
            uploadFailed: '上传失败，请重试。',
            validationFailed: '图片验证失败，请检查文件格式和大小。',
            itemNotFound: '清单项不存在。',
            networkError: '网络错误，请检查您的连接。',
            imageTooLarge: '图片太大！请选择小于5MB的图片。',
            invalidType: '不支持的图片格式！请选择 JPG、PNG、GIF 或 WebP 格式的图片。',
            tooEarly: '未到打扫时间，无法开始任务。',
            otherArea: '其他区域',
            remarks: '备注',
            remarksPlaceholder: '请输入备注信息...',
        },
        notifications: {
            title: '消息通知',
        },
        profile: {
            title: '个人中心',
            role: '保洁专员',
            backToTasks: '返回任务列表',
            changePassword: '修改密码',
            logout: '退出登录',
        },
        changePassword: {
            title: '修改密码',
            oldPassword: '旧密码',
            oldPasswordPlaceholder: '请输入旧密码',
            newPassword: '新密码',
            newPasswordPlaceholder: '请输入新密码',
            confirmPassword: '确认新密码',
            confirmPasswordPlaceholder: '请再次输入新密码',
            submit: '确认修改',
            success: '密码修改成功！',
            errorMissing: '请填写所有字段',
            errorMismatch: '两次输入的新密码不一致',
            errorFailed: '修改失败',
        },
        register: {
            title: '注册账号',
            subtitle: '加入民宿保洁管理',
            usernameLabel: '用户名',
            usernamePlaceholder: '请输入用户名',
            emailLabel: '邮箱',
            emailPlaceholder: '请输入邮箱',
            passwordLabel: '密码',
            passwordPlaceholder: '请输入密码 (至少8位)',
            confirmPasswordLabel: '确认密码',
            confirmPasswordPlaceholder: '请再次输入密码',
            submitButton: '注册',
            submitting: '注册中...',
            success: '注册成功！正在跳转登录页面...',
            errorMissing: '请填写所有字段',
            errorMismatch: '两次输入的密码不一致',
            errorLength: '密码长度至少为8位',
            errorFailed: '注册失败，请稍后重试',
        },
        lineRegistration: {
            title: '清扫团队绑定',
            subtitle: '请输入姓名，系统会按姓名匹配员工账号。',
            nameLabel: '姓名',
            namePlaceholder: '请输入姓名',
            submitButton: '提交绑定',
            submitting: '提交中',
            success: '提交成功',
            failed: '提交失败，请联系管理员。',
            invalidName: '请输入有效姓名',
            conflict: '该 LINE 账号或姓名已绑定其他员工，请联系管理员。',
            missingLineInfo: '无法取得 LINE 登录信息，请重新打开菜单。',
        },
        lineNotice: {
            pendingActivation: '账号已绑定，请等待管理员开启打扫端登录。',
            pendingRegistration: '已提交绑定申请，请等待管理员开启登录。',
            autoLoginFailed: 'LINE 自动登录失败，请重新打开菜单或联系管理员。',
            autoLoginAfterBindFailed: '绑定成功，但自动登录失败，请重新打开菜单。',
            missingLineInfo: '无法取得 LINE 登录信息，请重新打开菜单。',
        },
        status: {
            pending: '待打扫',
            inProgress: '进行中',
            completed: '已完成',
            reviewing: '待审核',
            rework: '返工',
        },
        nav: {
            tasks: '任务',
            notifications: '通知',
            profile: '我的',
            inventory: '消耗品',
        },
        inventory: {
            title: '消耗品库存',
            refreshTitle: '刷新库存',
            searchPlaceholder: '搜索物品...',
            lowStock: '低库存',
            consume: '出库',
            restock: '入库',
            noItems: '没有找到相关物品',
            consumeTitle: '出库 (使用)',
            restockTitle: '入库 (补充)',
            quantity: '数量',
            currentQuantity: '当前',
            remarksOptional: '备注 (可选)',
            remarksPlaceholder: '用途、来源等...',
            next: '下一步',
            warehouse: '仓库',
            item: '物品',
            remarks: '备注',
            backToEdit: '返回修改',
            confirmConsume: '确认出库',
            confirmRestock: '确认入库',
            invalidQuantity: '请输入有效的数量',
            operationFailed: '操作失败：',
            unknownWarehouse: '未知仓库',
        },
        common: {
            loading: '加载中...',
            viewImage: '放大查看',
            deletePhoto: '删除照片',
        },
        rooms: {
            title: '房间列表',
            name: '名称',
            bedsName: '床型',
            minPrice: '最低价',
            promoPrice: '活动价',
            strategy: '调价策略',
            configure: '配置',
        },
        strategies: {
            title: '调价策略',
            id: 'ID',
            name: '名称',
            type: '类型',
            discountDays: '折扣天数',
            rate: '加减费率(%)',
            checkStart: '检测时间',
            checkEnd: '检测结束时间',
            bindRooms: '绑定房间',
            updatedAt: '修改时间',
            createdAt: '创建时间',
            actions: '操作',
            syncDaily: '立即同步日常价',
            syncLog: '同步日志',
            selectAll: '全选',
            unselectAll: '取消全选',
            submit: '提交',
            close: '关闭'
        }
    },
    ja: {
        login: {
            title: '民泊清掃管理',
            subtitle: 'アカウントにログインしてください',
            testAccount: 'テストアカウント',
            password: 'パスワード',
            emailLabel: 'メールアドレス',
            emailPlaceholder: 'メールアドレスを入力',
            passwordLabel: 'パスワード',
            passwordPlaceholder: 'パスワードを入力',
            captchaLabel: '認証コード',
            captchaPlaceholder: '認証コード',
            loginButton: 'ログイン',
            loggingIn: 'ログイン中...',
            registerLink: 'アカウントをお持ちでないですか？登録',
            success: 'ログイン成功！転送中...',
            errorMissing: 'メールアドレスとパスワードを入力してください',
            errorCaptcha: '認証コードが間違っています',
            errorLogin: 'ログインに失敗しました。メールアドレスとパスワードを確認してください',
            errorBanned: 'アカウントが停止されています',
        },
        register: {
            title: 'アカウント登録',
            subtitle: '民泊清掃管理に参加',
            usernameLabel: 'ユーザー名',
            usernamePlaceholder: 'ユーザー名を入力',
            emailLabel: 'メールアドレス',
            emailPlaceholder: 'メールアドレスを入力',
            passwordLabel: 'パスワード',
            passwordPlaceholder: 'パスワードを入力 (8文字以上)',
            confirmPasswordLabel: 'パスワード確認',
            confirmPasswordPlaceholder: 'パスワードを再入力',
            submitButton: '登録',
            submitting: '登録中...',
            success: '登録成功！ログインページへ移動中...',
            errorMissing: 'すべてのフィールドに入力してください',
            errorMismatch: 'パスワードが一致しません',
            errorLength: 'パスワードは8文字以上である必要があります',
            errorFailed: '登録に失敗しました。後でもう一度お試しください',
        },
        lineRegistration: {
            title: '清掃スタッフ連携',
            subtitle: '氏名を入力してください。システムが氏名でスタッフアカウントを照合します。',
            nameLabel: '氏名',
            namePlaceholder: '氏名を入力',
            submitButton: '連携を送信',
            submitting: '送信中',
            success: '送信しました',
            failed: '送信に失敗しました。管理者に連絡してください。',
            invalidName: '有効な氏名を入力してください',
            conflict: 'このLINEアカウントまたは氏名は別のスタッフに連携されています。管理者に連絡してください。',
            missingLineInfo: 'LINEログイン情報を取得できません。メニューを開き直してください。',
        },
        lineNotice: {
            pendingActivation: 'アカウントは連携済みです。管理者が清掃アプリの利用を有効にするまでお待ちください。',
            pendingRegistration: '申請を送信しました。管理者がログインを有効にするまでお待ちください。',
            autoLoginFailed: 'LINE自動ログインに失敗しました。メニューを開き直すか、管理者に連絡してください。',
            autoLoginAfterBindFailed: '連携は完了しましたが、自動ログインに失敗しました。メニューを開き直してください。',
            missingLineInfo: 'LINEログイン情報を取得できません。メニューを開き直してください。',
        },
        status: {
            pending: '未清掃',
            inProgress: '清掃中',
            completed: '完了',
            reviewing: '確認中',
            rework: 'やり直し',
        },
        tasks: {
            title: 'マイタスク',
            today: '今日のタスク',
            history: '履歴',
            emptyToday: '今日のタスクはありません。ゆっくり休んでください！',
            emptyHistory: '履歴はありません',
            planTime: '予定時間',
            cleaningTime: '清掃時間',
            checkOutDate: 'チェックアウト日',
            rooms: '部屋',
            reworkReason: '理由',
        },
        workPlan: {
            entryButton: '勤務予定を提出',
            kicker: 'Work Plan',
            title: '勤務予定を提出',
            back: 'タスクへ戻る',
            currentUser: '提出者',
            loadingUser: '確認中',
            loadingWarehouse: '倉庫を読み込み中',
            warehouse: '所属倉庫',
            noWarehouse: '提出できる倉庫がありません。管理者に連絡してください。',
            prevWeek: '前週',
            nextWeek: '翌週',
            weekTitle: '翌週の勤務可能時間',
            workDaysUnit: ' 日勤務可',
            available: '勤務可',
            notePlaceholder: '備考',
            submit: '翌週の勤務可能時間を提出',
            saving: '提出中...',
            saved: '勤務可能時間を提出しました',
            loadFailed: '勤務予定の読み込みに失敗しました。後でもう一度お試しください。',
            saveFailed: '勤務予定の提出に失敗しました。後でもう一度お試しください。',
            mySchedule: '自分のシフト',
            unassigned: '未割当',
            scheduleEmpty: 'シフトデータはありません',
        },
        taskDetail: {
            title: 'タスク実行',
            historyTitle: '履歴タスク',
            reworkReason: 'やり直し理由:',
            standardExample: '手本',
            myPhoto: '私の写真',
            clickUpload: 'アップロード',
            submit: '完了して提出',
            submitting: '提出中...',
            cleanerRemarks: '清掃に関する注意事項',
            cantSubmitTitle: '提出できません',
            cantSubmitMsg: '必須写真がすべてアップロードされ、すべての項目がチェックされていることを確認してください。',
            ok: 'OK',
            uploadFailed: 'アップロードに失敗しました。再試行してください。',
            validationFailed: '画像の検証に失敗しました。ファイル形式とサイズを確認してください。',
            itemNotFound: '項目が見つかりません。',
            networkError: 'ネットワークエラー。接続を確認してください。',
            imageTooLarge: '画像が大きすぎます！5MB未満の画像を選択してください。',
            invalidType: 'サポートされていない画像形式です！JPG、PNG、GIF、またはWebP形式を選択してください。',
            tooEarly: '清掃時間になっていないため、タスクを開始できません。',
            otherArea: 'その他のエリア',
            remarks: '備考',
            remarksPlaceholder: '備考を入力してください...',
        },
        notifications: {
            title: '通知',
        },
        profile: {
            title: 'マイページ',
            role: '清掃スタッフ',
            backToTasks: 'タスク一覧に戻る',
            changePassword: 'パスワード変更',
            logout: 'ログアウト',
        },
        changePassword: {
            title: 'パスワード変更',
            oldPassword: '現在のパスワード',
            oldPasswordPlaceholder: '現在のパスワードを入力',
            newPassword: '新しいパスワード',
            newPasswordPlaceholder: '新しいパスワードを入力',
            confirmPassword: '新しいパスワード（確認）',
            confirmPasswordPlaceholder: '新しいパスワードを再入力',
            submit: '変更を確認',
            success: 'パスワードが変更されました！',
            errorMissing: 'すべてのフィールドに入力してください',
            errorMismatch: '新しいパスワードが一致しません',
            errorFailed: '変更に失敗しました',
        },
        nav: {
            tasks: 'タスク',
            notifications: '通知',
            profile: 'マイページ',
            inventory: '消耗品',
        },
        inventory: {
            title: '消耗品在庫',
            refreshTitle: '在庫を更新',
            searchPlaceholder: '物品を検索...',
            lowStock: '在庫不足',
            consume: '出庫',
            restock: '入庫',
            noItems: '該当する物品が見つかりません',
            consumeTitle: '出庫 (使用)',
            restockTitle: '入庫 (補充)',
            quantity: '数量',
            currentQuantity: '現在',
            remarksOptional: '備考 (任意)',
            remarksPlaceholder: '用途、入手元など...',
            next: '次へ',
            warehouse: '倉庫',
            item: '物品',
            remarks: '備考',
            backToEdit: '修正に戻る',
            confirmConsume: '出庫を確定',
            confirmRestock: '入庫を確定',
            invalidQuantity: '有効な数量を入力してください',
            operationFailed: '操作に失敗しました：',
            unknownWarehouse: '不明な倉庫',
        },
        common: {
            loading: '読み込み中...',
            viewImage: '拡大表示',
            deletePhoto: '写真を削除',
        },
        rooms: {
            title: '部屋一覧',
            name: '名称',
            bedsName: 'ベッドタイプ',
            minPrice: '最低価格',
            promoPrice: 'キャンペーン価格',
            strategy: '価格調整',
            configure: '設定',
        },
        strategies: {
            title: '価格調整',
            id: 'ID',
            name: '名称',
            type: 'タイプ',
            discountDays: '割引日数',
            rate: '増減率(%)',
            checkStart: '検知開始',
            checkEnd: '検知終了',
            bindRooms: '部屋を紐付け',
            updatedAt: '更新日時',
            createdAt: '作成日時',
            actions: '操作',
            syncDaily: '日次価格を同期',
            syncLog: '同期ログ',
            selectAll: '全選択',
            unselectAll: '選択解除',
            submit: '送信',
            close: '閉じる'
        }
    }
};
